import { ChangeDetectionStrategy, Component, inject, Injectable, OnDestroy } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { LgTranslateService, useTranslationNamespace } from "@logex/framework/lg-localization";
import {
    getDialogFactoryBase,
    IDialogComponent,
    LgDialogFactory,
    LgDialogRef
} from "@logex/framework/ui-core";
import { BehaviorSubject, lastValueFrom, Subscription } from "rxjs";

@Component({
    selector: "mod-save-initiative",
    templateUrl: "./save-initiative-dialog.component.html",
    viewProviders: [useTranslationNamespace("APP._InitiativeCreator")],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SaveInitiativeDialogComponent
    implements IDialogComponent<SaveInitiativeDialogComponent>, OnDestroy
{
    protected _dialogRef = inject(LgDialogRef<SaveInitiativeDialogComponent>);
    protected _lgTranslate = inject(LgTranslateService);
    _dialogClass = "lg-dialog lg-dialog--3col";
    _title = this._lgTranslate.translate(".DialogTitle");

    form: FormGroup | null = null;
    private _subscription: Subscription | null = null;
    private _result = new BehaviorSubject<"correct" | boolean | null>(null);

    private _addInitiative = true;

    ngOnDestroy(): void {
        if (this._subscription != null) this._subscription.unsubscribe();
    }

    async open(): Promise<"correct" | boolean | null> {
        this.form = new FormGroup({
            addInitiative: new FormControl()
        });
        this.form.reset({ addInitiative: true });
        this._subscription = this.form.valueChanges.subscribe(
            (x: { addInitiative: boolean }) => (this._addInitiative = x.addInitiative)
        );

        return lastValueFrom(this._result);
    }

    get addInitiative() {
        return this._addInitiative;
    }

    correctValue() {
        this._result.next("correct");
        this._result.complete();
        this._dialogRef.close();
    }

    saveOrDefault() {
        this._result.next(this.addInitiative);
        this._result.complete();
        this._dialogRef.close();
    }

    _onClose(dialog: LgDialogRef<SaveInitiativeDialogComponent, any>) {
        this._result.next(null);
        this._result.complete();
        dialog.close();
    }
}

@Injectable()
export class SaveInitiativeDialog extends getDialogFactoryBase(
    SaveInitiativeDialogComponent,
    "open"
) {
    constructor() {
        super(inject(LgDialogFactory));
    }
}
